module.exports = __webpack_public_path__ + "24b0df02040e67135e1b4c8c0e6eb2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_header_show_2x.png
// module id = 106
// module chunks = 0 1 2 3 4